<template>
  <div>
    <azure-storage
      v-if="selectedId != null"
      :id="selectedId"
      prefix="bonCoupFiles"
      :value="fileUploaderOpen"
      @success="refreshGrid"
      @input="fileUploaderOpen = $event"
    />
    <dashboard-bon-coup-email
      v-model="showClientMailForm"
      :client-id="currentClientId"
      :client-name="currentClientName"
      :is-read-only="isReadOnly"
      :as-of-date="asOfDate"
      @input="showClientMailForm = $event"
    />
    <dashboard-bon-coup-confirm-form
      v-model="showDashboardBonCoupConfirmForm"
      :monthly-report-sending-id="monthlyReportSendingId"
      :analyst-email="analystEmail"
      :responsible-email="responsibleEmail"
      :as-of-date="asOfDate"
      @success="onDashboardBonCoupSend"
      @input="showDashboardBonCoupConfirmForm = $event"
    />
    <bon-coup-new-list-confirm-form
      v-model="showBonCoupNewListConfirmForm"
      :as-of-date="this.asOfDate"
      @success="onBonCoupNewListConfirm"
      @input="showBonCoupNewListConfirmForm = $event"
    />
    <dashboard-bon-coup-validate-all-confirm-form
      v-model="showValidateAllConfirm"
      :as-of-date="this.asOfDate"
      :responsible-email="responsibleEmail"
      @success="onValidateAllConfirm"
      @input="showValidateAllConfirm = $event"
    />
    <sending-message-window
      v-model="showSendingMessageWindow"
      :sending-message-id="sendingMessageId"
      :monthly-report-sending-id="monthlyReportSendingId"
      :monthly-report-sending-list-detail-id="monthlyReportSendingListDetailId"
      :language-id="languageId"
      :as-of-date="asOfDate"
      :selected-client-id="selectedClientId"
      :title="sendingMessageTitle"
      :editable="bonCoupEditable"
      @success="onSendingMessageSuccess"
      v-if="showSendingMessageWindow"
      @input="showSendingMessageWindow = $event"
    />
    <dashboard-bon-coup-preview
      v-model="showSendingMessagePreview"
      :monthly-report-sending-id="monthlyReportSendingId"
      :monthly-report-sending-list-detail-id="monthlyReportSendingListDetailId"
      :as-of-date="asOfDate"
      @input="toggleSendingMessagePreview($event)"
    />

    <page-toolbar height="100px">
      <vonap-toolbar-label label="Month">
        <kendo-datepicker
          :value="asOfDate"
          :format="'MMM yyyy'"
          :start="'year'"
          :depth="'year'"
          style="width:108px"
          @change="asOfDatePickerChanged"
        ></kendo-datepicker>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Analyst">
        <analyst-email v-model="analystEmail" @change="analystEmailChanged" />
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Responsible">
        <responsible-email v-model="responsibleEmail" @change="responsibleEmailChanged" />
      </vonap-toolbar-label>
      <vonap-toolbar-label label="">
        <kendo-button icon="add" title="Add" v-show="!isReadOnly" @click="addNew"> </kendo-button>
        <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
        <kendo-button
          icon="file-add"
          title="New List"
          v-show="!isReadOnly"
          @click="toggleBonCoupNewListConfirmForm"
        >
        </kendo-button>
        <kendo-button
          type="button"
          title="Calculate Statistics"
          class="k-button-icon"
          :disabled="calculating"
          @click="calculateStatistics"
        >
          <i class="fa fa-bolt"></i>
        </kendo-button>
        <kendo-button
          type="button"
          title="Validate/Unvalidate All"
          class="k-button-icon"
          :disabled="calculating"
          @click="validateAllToBeSend"
        >
          <i class="fa fa-check"></i>
        </kendo-button>
        <kendo-button type="button" title="Send All" class="k-button-icon" @click="sendAllMail">
          <i class="fa fa-paper-plane"></i>
        </kendo-button>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Show only Unsent">
        <v-switch
          @change="showOnlyUnsentChanged"
          v-model="showOnlyUnsent"
          :style="'display:inline-block;margin:-6px 0;width:61px;top: 4px;position:relative'"
        >
        </v-switch>
      </vonap-toolbar-label>
      <v-progress-circular
        indeterminate
        style="height:40px;width:40px;position:relative;z-index:1;right:-32px"
        v-if="calculating"
      />
    </page-toolbar>
    <kendo-grid
      ref="grid"
      :height="'calc(100vh - 282px)'"
      :dataSource="topDataSource"
      :autoBind="false"
      :editable="!isReadOnly && 'inline'"
      :filterable="true"
      :sortable="true"
      :pageable="false"
      :columns="topColumns"
      :detailInit="detailInit"
      :detailExpand="topDetailExpand"
      :detailCollapse="topDetailCollapse"
      @databound="dataBound"
      @cancel="dataBound"
    >
    </kendo-grid>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import {mapGetters} from 'vuex'
import {getDataItem} from '@/helpers/kendo-helpers'
import {
  checkboxColumn,
  datePickerEditor,
  jsonDropDownEditor,
  readOnlyEditor,
} from '@/helpers/kendo-editors'
import PageToolbar from '@/components/PageToolbar'
import params from '@/helpers/params'
import DashboardBonCoupEmail from '@/views/Report/DashboardBonCoupEmail'
import DashboardBonCoupConfirmForm from '@/components/DashboardBonCoupConfirmForm'
import security from '@/mixins/security'
import notification from '@/helpers/notification'
import AzureStorage from '@/components/AzureStorage'
import BonCoupNewListConfirmForm from '@/components/BonCoupNewListConfirmForm'
import DashboardBonCoupValidateAllConfirmForm from '@/components/DashboardBonCoupValidateAllConfirmForm'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import AnalystEmail from '@/components/AnalystEmail'
import ResponsibleEmail from '@/components/ResponsibleEmail'
import SendingMessageWindow from '@/components/SendingMessageWindow'
import DashboardBonCoupPreview from '@/views/Report/DashboardBonCoupPreview'

const $ = kendo.jQuery

export default {
  name: 'DashboardBonCoup',
  mixins: [security],
  mounted() {
    this.getData()
    document.body.addEventListener('click', this.linkClick, false)
    document.body.addEventListener('click', this.azureStorageOpenClick, false)
    const grid = this.$refs.grid.kendoWidget()
    grid.element
      .kendoTooltip({
        show: function() {
          if (this.content.text().length > 32) {
            this.content.parent().css('visibility', 'visible')
          }
        },
        hide: function() {
          this.content.parent().css('visibility', 'hidden')
        },
        filter: 'td:nth-child(9)', //this filter selects the first column cells
        position: 'top',
        content: function(e) {
          const dataItem = grid.dataItem(e.target.closest('tr'))
          const content = dataItem.clientName
          return content
        },
      })
      .data('kendoTooltip')
    grid.element
      .kendoTooltip({
        show: function() {
          if (this.content.text().length > 10) {
            this.content.parent().css('visibility', 'visible')
          }
        },
        hide: function() {
          this.content.parent().css('visibility', 'hidden')
        },
        filter: 'td:nth-child(11)',
        position: 'top',
        content: function(e) {
          const dataItem = grid.dataItem(e.target.closest('tr'))
          const content = dataItem.comments
          return content
        },
      })
      .data('kendoTooltip')
    grid.element
      .kendoTooltip({
        show: function() {
          if (this.content.text().length > 10) {
            this.content.parent().css('visibility', 'visible')
          }
        },
        hide: function() {
          this.content.parent().css('visibility', 'hidden')
        },
        filter: 'td:nth-child(14)',
        position: 'top',
        content: function(e) {
          const dataItem = grid.dataItem(e.target.closest('tr'))
          const content = dataItem.mailTitle
          return content
        },
      })
      .data('kendoTooltip')
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.linkClick)
    document.body.removeEventListener('click', this.azureStorageOpenClick)
  },
  data() {
    return {
      asOfDate: null,
      expandedMonthlyReportSendingListDetailId: -1,
      topDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: false,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          create: {
            type: 'POST',
            url: '/api/report/monthlyReportSendingList',
            dataType: 'json',
            complete: () => {
              this.gridRefresh()
            },
          },
          read: {
            type: 'GET',
            url: '/api/report/monthlyReportSendingList',
            data: () => ({
              asOfDate: this.asOfDate,
              analystEmail: this.analystEmail,
              responsibleEmail: this.responsibleEmail,
              showOnlyUnsent: this.showOnlyUnsent,
            }),
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/report/monthlyReportSendingList',
            dataType: 'json',
            complete: () => {
              this.gridRefresh()
            },
          },
          destroy: {
            type: 'DELETE',
            url: '/api/report/monthlyReportSendingList',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'monthlyReportSendingListId',
            fields: {
              monthlyReportSendingListId: {type: 'number', defaultValue: 0},
              statusId: {type: 'number', editable: true},
              statusName: {type: 'string', editable: true},
              clientId: {type: 'number', editable: true},
              clientName: {type: 'string', editable: true},
              comments: {type: 'string', editable: true},
              languageId: {type: 'number', editable: true, defaultValue: 1},
              languageName: {type: 'string', editable: true},
              reportDate: {
                type: 'date',
                editable: true,
                defaultValue: () => {
                  return this.asOfDate
                },
              },
              clientCall: {
                type: 'date',
                editable: true,
                defaultValue: () => {
                  const asOfDate = new Date(this.asOfDate)
                  let minDate = new Date(asOfDate.getFullYear(), asOfDate.getMonth() + 1, 1)
                  let lastDate = new Date(asOfDate.getFullYear(), asOfDate.getMonth() + 2, 0)
                  let week = 1
                  while (lastDate.getTime() >= minDate.getTime()) {
                    if (minDate.getDay() == 2) {
                      if (week == 3) {
                        return minDate
                      }
                      week = week + 1
                    }
                    minDate.setDate(minDate.getDate() + 1)
                  }
                  return minDate
                },
              },
              from: {type: 'string', editable: true},
              to: {type: 'string', editable: true},
              sendingDate: {type: 'date', editable: false, defaultValue: null},
              sendingUser: {type: 'string', editable: false, defaultValue: null},
              mailTitle: {type: 'string', editable: true},
              dashboardId: {type: 'number', editable: true},
              dashboardName: {type: 'string', editable: true},
              canDelete: {type: 'boolean', defaultValue: true, editable: false},
            },
          },
        },
      }),
      currentClientId: 0,
      currentClientName: '',
      showClientMailForm: false,
      monthlyReportSendingId: 0,
      showDashboardBonCoupConfirmForm: false,
      selectedId: null,
      fileUploaderOpen: false,
      showBonCoupNewListConfirmForm: false,
      showValidateAllConfirm: false,
      responsibleEmail: 'ALL',
      analystEmail: 'ALL',
      showOnlyUnsent: false,
      sendingMessageId: 0,
      monthlyReportSendingListDetailId: 0,
      languageId: 1,
      sendingMessageTitle: null,
      selectedClientId: null,
      bonCoupEditable: false,
      showSendingMessageWindow: false,
      showSendingMessagePreview: false,
      subjectFormatData: [{textValue: 'left'}, {textValue: 'center'}, {textValue: 'right'}],
      textFormatData: [
        {textValue: 'normal'},
        {textValue: 'bold'},
        {textValue: 'italic'},
        {textValue: 'underline'},
      ],
      calculating: false,
    }
  },
  methods: {
    async getData() {
      const request = await axios
        .get('/api/report/monthlyReportSendingList/getLastDate')
        .catch(() => notification('Error ', 'error'))
      let asOfDate = kendo.toString(request.data, 'yyyy-MM-dd')
      this.asOfDate = asOfDate
      this.gridRefresh()
    },
    dataBound: function(e) {
      setTimeout(() => {
        const rows = e.sender.tbody.children()
        for (let j = 0; j < rows.length; j++) {
          const row = $(rows[j])
          const dataItem = e.sender.dataItem(row)
          const status = dataItem.get('statusName').replaceAll(' ', '')
          row.addClass(status)
        }
      }, 100)
    },
    statusEditor(container, options) {
      const isNew = options.model.monthlyReportSendingListId == 0
      const currentStatusId = isNew ? -1 : options.model.statusId
      return jsonDropDownEditor('statusId', 'statusName', '', {
        dataSource: {
          transport: {
            read: {
              url: '/api/report/monthlyReportSendingList/GetStatus',
              data: () => ({
                currentStatusId: currentStatusId,
              }),
              contentType: 'application/json',
              type: 'GET',
            },
          },
        },
      }).call(this, container, options)
    },
    clientEditor(container, options) {
      const isReadOnly = options.model.statusName == 'Sent' || !options.model.canDelete
      if (isReadOnly) return readOnlyEditor.call(this, container, options)

      const isNew = options.model.monthlyReportSendingListId == 0
      const selectedClientId = isNew ? -1 : options.model.clientId
      return jsonDropDownEditor('clientId', 'clientName', '', {
        dataSource: {
          transport: {
            read: {
              url: '/api/report/monthlyReportSendingList/GetClients',
              data: () => ({
                asOfDate: this.asOfDate,
                clientId: selectedClientId,
              }),
              contentType: 'application/json',
              type: 'GET',
            },
          },
        },
        filter: 'contains',
        change: async e => {
          const dataItem = e.sender.dataItem()
          let rowItem = getDataItem(e.sender.element)
          rowItem.set('clientId', dataItem.clientId)
          rowItem.set('clientName', dataItem.clientName)

          const dashboardDropDown = kendo.jQuery('#dashboardId').getKendoDropDownList()
          await dashboardDropDown.dataSource.read()
          dashboardDropDown.select(0)
          dashboardDropDown.trigger('change')
        },
      }).call(this, container, options)
    },
    clientCallEditor(container, options) {
      const isReadOnly = options.model.statusName == 'Sent'
      if (isReadOnly) return readOnlyEditor.call(this, container, options)

      const input = $('<input/>')
      input.attr('name', options.field)
      input.appendTo(container)
      input.kendoDateTimePicker({format: 'yyyy-MM-dd hh:mh tt'})
      return input
    },
    languageEditor(container, options) {
      const isReadOnly = options.model.statusName == 'Sent' || !options.model.canDelete
      if (isReadOnly) return readOnlyEditor.call(this, container, options)

      return jsonDropDownEditor('languageId', 'languageName', '', {
        dataSource: {
          transport: {
            read: {
              url: '/api/report/monthlyReportSendingList/GetLanguages',
              contentType: 'application/json',
              type: 'GET',
            },
          },
        },
        filter: 'contains',
        change: async () => {
          const dashboardDropDown = kendo.jQuery('#dashboardId').getKendoDropDownList()
          await dashboardDropDown.dataSource.read()
          dashboardDropDown.select(0)
          dashboardDropDown.trigger('change')
        },
      }).call(this, container, options)
    },
    reportDateEditor(container, options) {
      if (options.model.statusName == 'Sent') return readOnlyEditor.call(this, container, options)

      return datePickerEditor({format: 'MMM yyyy', start: 'year', depth: 'year'}, true).call(
        this,
        container,
        options,
      )
    },
    mailTitleEditor(container, options) {
      if (options.model.statusName == 'Sent') return readOnlyEditor.call(this, container, options)

      let input = $(
        '<input class="k-textbox" id="mailTitle"  name="' + options.field + '" maxlength="832" />',
      )
      input.appendTo(container)
      return
    },
    fromEditor(container, options) {
      if (options.model.statusName == 'Sent') return readOnlyEditor.call(this, container, options)

      let input = $(
        '<input class="k-textbox" id="from"  name="' + options.field + '" maxlength="82" />',
      )
      input.appendTo(container)
      return
    },
    dashboardEditor(container, options) {
      if (options.model.statusName == 'Sent') return readOnlyEditor.call(this, container, options)

      return jsonDropDownEditor('dashboardId', 'dashboardName', '', {
        dataSource: {
          transport: {
            read: {
              url: '/api/report/monthlyReportSendingList/GetDashboards',
              data: () => ({
                clientId: options.model.clientId,
                languageId: options.model.languageId,
              }),
              contentType: 'application/json',
              type: 'GET',
            },
          },
        },
        filter: 'contains',
        change: e => {
          const dataItem = e.sender.dataItem()
          let rowItem = getDataItem(e.sender.element)
          rowItem.set('dashboardId', dataItem.dashboardId)
          rowItem.set('dashboardName', dataItem.dashboardName)
        },
      }).call(this, container, options)
    },
    sendingMessageReportEditor(container, options) {
      return jsonDropDownEditor('sendingMessageReportId', 'sendingMessageReportName', '', {
        dataSource: {
          transport: {
            read: {
              url: '/api/report/monthlyReportSendingList/GetSendingMessageReport',
              contentType: 'application/json',
              type: 'GET',
            },
          },
        },
        filter: 'contains',
        change: async () => {
          const messageDropDown = kendo.jQuery('#sendingMessageId').getKendoDropDownList()
          await messageDropDown.dataSource.read()
          messageDropDown.select(0)
          messageDropDown.trigger('change')
        },
      }).call(this, container, options)
    },
    sendingMessageNameEditor(container, options) {
      return jsonDropDownEditor('sendingMessageId', 'sendingMessageName', '', {
        dataSource: {
          transport: {
            read: {
              url: '/api/report/monthlyReportSendingList/GetSendingMessage',
              data: () => ({
                sendingMessageReportId: options.model.sendingMessageReportId,
                clientId: options.model.clientId,
                languageId: options.model.languageId,
              }),
              contentType: 'application/json',
              type: 'GET',
            },
          },
        },
        filter: 'contains',
        change: e => {
          const dataItem = e.sender.dataItem()
          let rowItem = getDataItem(e.sender.element)
          rowItem.set('sendingMessageId', dataItem.sendingMessageId)
          rowItem.set('sendingMessageName', dataItem.sendingMessageName)
        },
      }).call(this, container, options)
    },
    subjectFormatEditor(container, options) {
      return jsonDropDownEditor('textValue', 'textValue', '', {
        dataSource: this.subjectFormatData,
        change: e => {
          let rowItem = getDataItem(e.sender.element)
          rowItem.set('subjectFormat', e.sender.text())
        },
      }).call(this, container, options)
    },
    textFormatEditor(container, options) {
      return jsonDropDownEditor('textValue', 'textValue', '', {
        dataSource: this.textFormatData,
        change: e => {
          let rowItem = getDataItem(e.sender.element)
          rowItem.set('textFormat', e.sender.text())
        },
      }).call(this, container, options)
    },
    gridRefresh() {
      const grid = this.$refs.grid.kendoWidget()
      grid.dataSource.read()
    },
    addNew() {
      const grid = this.$refs.grid.kendoWidget()
      grid.addRow()
    },
    asOfDatePickerChanged(e) {
      let asOfDate = kendo.toString(e.sender.value(), 'yyyy-MM-dd')
      this.asOfDate = asOfDate
      this.gridRefresh()
    },
    exportToExcel() {
      const exportUrl = '/api/report/monthlyReportSendingList/exportToExcel'
      const qs = params.fromObject({
        asOfDate: this.asOfDate,
        analystEmail: this.analystEmail,
        responsibleEmail: this.responsibleEmail,
        showOnlyUnsent: this.showOnlyUnsent,
        t: this.tokenString,
      })
      location.href = `${exportUrl}?${qs}`
    },
    topDetailExpand(ev) {
      const grid = $(ev.sender.wrapper).data('kendoGrid')
      let expandedRow = $(ev.sender.wrapper).data('expandedRow')
      if (expandedRow && expandedRow[0] != ev.masterRow[0]) {
        grid.collapseRow(expandedRow)
      }
      $(ev.sender.wrapper).data('expandedRow', ev.masterRow)
      grid.hideColumn(15)
    },
    topDetailCollapse(ev) {
      const grid = $(ev.sender.wrapper).data('kendoGrid')
      let expandedRow = $(ev.sender.wrapper).data('expandedRow')
      expandedRow
        .next()
        .find('.k-grid')
        .getKendoGrid()
        .destroy()
      expandedRow.next().remove()
      //this.gridRefresh()
      grid.showColumn(15)
    },
    detailInit(e) {
      const vm = this
      const editable = !vm.isReadOnly && +e.data.statusId != 2
      const monthlyReportSendingListId = +e.data.monthlyReportSendingListId
      const clientId = +e.data.clientId
      const languageId = +e.data.languageId
      const $container = $("<div id='detailGrid'/>")
      const columns = [
        {
          template: '<span class="k-icon k-i-reorder drag-handle" title="Drag to reorder" />',
          attributes: {class: 'drag-handle', style: 'text-align:center;padding:2px 0'},
          width: 40,
          hidden: !editable,
        },
        {
          command: [{name: 'edit', iconClass: {update: 'k-icon k-i-check'}}],
          attributes: {style: 'text-align:center;padding:2px 0'},
          width: 40,
          hidden: !editable,
        },
        {
          width: 40,
          attributes: {style: 'text-align:center;padding:0'},
          filterable: false,
          sortable: false,
          template: () => {
            return `<button title="Open Message" style="height:24px" data-editable="${editable}" class="k-button k-button-icon sendingMessageDrilldown" role="button"><i data-editable="${editable}" class="sendingMessageDrilldown fa fa-list-alt"></i></button>`
          },
        },
        {
          width: 40,
          attributes: {style: 'text-align:center;padding:0'},
          filterable: false,
          sortable: false,
          template: () => {
            return `<button title="Preview" style="height:24px" class="k-button k-button-icon sendingMessageDetailPreview" role="button"><i class="sendingMessageDetailPreview fa fa-binoculars"></i></button>`
          },
        },
        {
          field: 'sendingMessageReport',
          title: 'Report',
          width: 182,
          attributes: {style: 'text-align:left'},
          editor: this.sendingMessageReportEditor,
        },
        {
          field: 'sendingMessageId',
          title: 'Message Name',
          width: 182,
          editor: this.sendingMessageNameEditor,
          template: '#:sendingMessageName# ',
        },
        checkboxColumn('showSubject', {title: 'Show Subject', width: 82}, !editable),
        {
          field: 'subjectFormat',
          title: 'Subject Format',
          width: 82,
          attributes: {style: 'text-align:center'},
          editor: this.subjectFormatEditor,
        },
        {
          field: 'textFormat',
          title: 'Text Format',
          width: 92,
          attributes: {style: 'text-align:center'},
          editor: this.textFormatEditor,
        },
        {
          editable: editable,
          command: [{name: 'destroy'}],
          attributes: {style: 'text-align:center;padding:0'},
          width: 40,
          hidden: !editable,
        },
        {},
      ]

      let detailGrid = $container
        .appendTo(e.detailCell)
        .kendoGrid({
          dataSource: {
            type: 'aspnetmvc-ajax',
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            pageSize: 30,
            transport: {
              create: {
                type: 'POST',
                url: '/api/report/monthlyReportSendingList/createDetail',
                complete: () => {
                  detailGrid.dataSource.read()
                },
                dataType: 'json',
              },
              read: {
                type: 'GET',
                url: '/api/report/monthlyReportSendingList/readDetail',
                data: () => ({monthlyReportSendingListId: monthlyReportSendingListId}),
                dataType: 'json',
              },
              update: {
                type: 'PUT',
                url: '/api/report/monthlyReportSendingList/updateDetail',
                dataType: 'json',
              },
              destroy: {
                type: 'DELETE',
                url: '/api/report/monthlyReportSendingList/deleteDetail',
                dataType: 'json',
              },
            },
            schema: {
              errors: 'errors',
              total: 'total',
              data: 'data',
              model: {
                id: 'monthlyReportSendingListDetailId',
                fields: {
                  monthlyReportSendingListDetailId: {
                    type: 'number',
                    editable: false,
                    defaultValue: 0,
                  },
                  monthlyReportSendingListId: {
                    type: 'number',
                    defaultValue: monthlyReportSendingListId,
                  },
                  sendingMessageId: {type: 'number', editable: true},
                  sendingMessageName: {type: 'string', editable: true},
                  sendingMessageReportId: {type: 'number', editable: true},
                  sendingMessageReport: {type: 'string', editable: true},
                  clientId: {type: 'number', editable: false, defaultValue: clientId},
                  languageId: {type: 'number', editable: false, defaultValue: languageId},
                  showSubject: {type: 'boolean', editable: true, defaultValue: true},
                  subjectFormat: {type: 'string', editable: true, defaultValue: 'center'},
                  textFormat: {type: 'string', editable: true, defaultValue: 'bold'},
                  sequence: {type: 'number'},
                },
              },
            },
          },
          toolbar: editable ? ['create'] : [],
          editable: editable && {mode: 'inline', createAt: 'bottom'},
          scrollable: true,
          sortable: false,
          pageable: false,
          columns: columns,
          detailExpand: function(ev) {
            let expandedRow = $(ev.sender.wrapper).data('expandedRow')
            if (expandedRow && expandedRow[0] != ev.masterRow[0]) {
              let grid = $(ev.sender.wrapper).data('kendoGrid')
              grid.collapseRow(expandedRow)
            }
            $(ev.sender.wrapper).data('expandedRow', ev.masterRow)
          },
          detailCollapse: function(ev) {
            let expandedRow = $(ev.sender.wrapper).data('expandedRow')
            expandedRow
              .next()
              .find('.k-grid')
              .getKendoGrid()
              .destroy()
            expandedRow.next().remove()
          },
          dataBound: function() {
            if (vm.expandedMonthlyReportSendingListDetailId != -1) {
              let detailDataItem = detailGrid.dataSource.get(
                vm.expandedMonthlyReportSendingListDetailId,
              )
              if (detailDataItem == null) {
                return
              }

              let row = detailGrid.tbody.find("tr[data-uid='" + detailDataItem.uid + "']")
              this.expandRow(row)
            }
          },
        })
        .data('kendoGrid')

      this.dragAndDropGrid(detailGrid, !editable)
    },
    dragAndDropGrid(grid, hide) {
      if (hide) {
        let dragAndDrop = grid.table.data('kendoSortable')
        if (dragAndDrop) dragAndDrop.destroy()
        grid.hideColumn(0)
      } else {
        if (this.isReadOnly) return
        grid.showColumn(0)
        grid.table.kendoSortable({
          handler: '.drag-handle',
          filter: 'tr:not(tr[data-role=editable])',
          hint: function(element) {
            var table = $('<table style="width: 600px;" class="k-grid k-widget"></table>')
            table.append(element.clone())
            table.css('opacity', 0.7)

            return table
          },
          cursor: 'move',
          placeholder: function() {
            return $('<tr colspan="4" class="placeholder"></tr>')
          },
          change: async e => {
            const skip = grid.dataSource.skip(),
              newIndex = e.newIndex + skip,
              selectedDataItem = grid.dataSource.getByUid(e.item.data('uid'))

            grid.dataSource.remove(selectedDataItem)
            grid.dataSource.insert(newIndex, selectedDataItem)

            await axios.post('/api/report/monthlyReportSendingList/updateSequence', {
              monthlyReportSendingListId: selectedDataItem.monthlyReportSendingListId,
              monthlyReportSendingListDetailId: selectedDataItem.monthlyReportSendingListDetailId,
              newIndex: e.newIndex,
            })
            await grid.dataSource.read()
          },
        })
      }
    },
    onDashboardBonCoupSend() {
      this.showDashboardBonCoupConfirmForm = false
      this.gridRefresh()
    },
    onBonCoupNewListConfirm() {
      this.showBonCoupNewListConfirmForm = false
      this.gridRefresh()
    },
    toggleBonCoupNewListConfirmForm() {
      this.showBonCoupNewListConfirmForm = !this.showBonCoupNewListConfirmForm
    },
    toggleSendingMessagePreview(e) {
      this.showSendingMessagePreview = e
      if (!this.showSendingMessagePreview) {
        this.monthlyReportSendingId = 0
        this.monthlyReportSendingListDetailId = 0
      }
    },
    linkClick({target}) {
      let dataItem
      try {
        dataItem = getDataItem(target)
      } catch (err) {
        return
      }
      if (/clientLink/.test(target.className)) {
        this.currentClientId = +dataItem.clientId
        this.currentClientName = dataItem.clientName
        this.showClientMailForm = true
      } else if (/sendEmailLink/.test(target.className)) {
        this.monthlyReportSendingId = +dataItem.monthlyReportSendingListId
        this.showDashboardBonCoupConfirmForm = true
      } else if (/sendingMessageDrilldown/.test(target.className)) {
        const editable = target.dataset.editable == 'true'
        this.bonCoupEditable = editable
        this.sendingMessageId = +dataItem.sendingMessageId
        this.monthlyReportSendingId = +dataItem.monthlyReportSendingListId
        this.monthlyReportSendingListDetailId = +dataItem.monthlyReportSendingListDetailId
        this.languageId = +dataItem.languageId
        this.sendingMessageTitle = dataItem.title
        this.selectedClientId = dataItem.clientId
        this.showSendingMessageWindow = true
      } else if (/sendingMessageDetailPreview/.test(target.className)) {
        this.monthlyReportSendingId = +dataItem.monthlyReportSendingListId
        this.monthlyReportSendingListDetailId = +dataItem.monthlyReportSendingListDetailId
        this.toggleSendingMessagePreview(true)
      } else if (/emailPreviewLink/.test(target.className)) {
        this.monthlyReportSendingId = +dataItem.monthlyReportSendingListId
        this.monthlyReportSendingListDetailId = -1
        this.toggleSendingMessagePreview(true)
      }
    },
    azureStorageOpenClick({target}) {
      if (!/azureStorageOpen/.test(target.className)) return

      const dataItem = getDataItem(target)
      this.selectedId = dataItem.monthlyReportSendingListId
      Vue.nextTick(() => {
        this.fileUploaderOpen = true
      })
    },
    refreshGrid() {
      return this.topDataSource.read()
    },
    analystEmailChanged() {
      this.refreshGrid()
    },
    responsibleEmailChanged() {
      this.refreshGrid()
    },
    sendAllMail() {
      this.showDashboardBonCoupConfirmForm = true
      this.monthlyReportSendingId = 0
    },
    showOnlyUnsentChanged() {
      this.refreshGrid()
    },
    onSendingMessageSuccess() {
      const id = this.monthlyReportSendingListDetailId
      this.monthlyReportSendingListDetailId = -1
      setTimeout(() => {
        kendo
          .jQuery('#detailGrid')
          .getKendoGrid()
          .dataSource.read()
        this.monthlyReportSendingListDetailId = id
      }, 100)
    },
    async calculateStatistics() {
      if (!confirm('Are your sure you want to calculate statistics for the selected Responsible ?'))
        return

      this.calculating = true
      const response = await axios
        .post('/api/report/monthlyReportSendingList/executeProcess', {
          asOfDate: this.asOfDate,
          clientId: 0,
          responsible: this.responsibleEmail,
        })
        .catch(() => {
          notification('Some error', 'error')
          this.calculating = false
        })

      if (response.status == 200) {
        notification('Process finished successfully!', 'info')
      }
      this.calculating = false
    },
    onValidateAllConfirm() {
      this.showValidateAllConfirm = false
      this.gridRefresh()
    },
    validateAllToBeSend() {
      this.showValidateAllConfirm = true
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    topColumns() {
      return [
        {
          editable: !this.isReadOnly,
          command: [{name: 'edit'}],
          attributes: {style: 'text-align:center;padding:2px 0'},
          width: 40,
        },
        checkboxColumn(
          'isValidated',
          {
            title: 'Validated',
            width: 82,
            customTemplate: function(dataItem) {
              const status = dataItem.statusName.replaceAll(' ', '')
              if (status !== 'ToBeSend') return ''
            },
          },
          false,
          null,
          function(item) {
            const status = item.statusName.replaceAll(' ', '')
            return status !== 'ToBeSend'
          },
        ),
        {
          width: 40,
          attributes: {style: 'text-align:center;padding:0'},
          filterable: false,
          sortable: false,
          template: () => {
            return `<button title="Email preview" style="height:24px" class="emailPreviewLink" role="button"><i class="emailPreviewLink fa fa-binoculars"></i></button>`
          },
        },
        {
          width: 40,
          attributes: {style: 'text-align:center;padding:0'},
          filterable: false,
          sortable: false,
          template: item => {
            const status = item.statusName.replaceAll(' ', '')
            if (status == 'DbNotFound') return ''

            return `<button title="Sending Email" style="height:24px" class="sendEmailLink" role="button"><i class="sendEmailLink fa fa-paper-plane"></i></button>`
          },
        },
        {
          width: 40,
          attributes: {style: 'text-align:center;padding:0'},
          filterable: false,
          sortable: false,
          template: () => {
            return `<button title="Mail List" style="height:24px" class="clientLink" role="button"><i class="clientLink fas fa-envelope"></i></button>`
          },
        },
        {
          width: 40,
          attributes: {style: 'text-align:center;padding:0'},
          template(dataItem) {
            if (dataItem.hasFiles) {
              return `<button title="Attached document" style="height:24px" class="azureStorageOpen" role="button"><i class="azureStorageOpen fas fa-paperclip"></i></button>`
            }

            return `<button title="Attached document" style="height:24px" class="azureStorageOpen" role="button"><i class="azureStorageOpen fa fa-folder-open"></i></button>`
          },
          filterable: false,
        },
        {
          field: 'statusName',
          title: 'Status',
          width: 132,
          attributes: {style: 'text-align:center'},
          filterable: false,
          sortable: false,
          editor: this.statusEditor,
        },
        {
          field: 'clientName',
          title: 'Client',
          width: 240,
          template:
            '#= clientName && clientName.length > 32 ? clientName.substring(0, 32) + "..." : (clientName || "") #',
          editor: this.clientEditor,
        },
        {
          field: 'clientCall',
          title: 'Client Call',
          format: '{0:yyyy-MM-dd h:mm tt}',
          width: 182,
          attributes: {style: 'text-align:left'},
          editor: this.clientCallEditor,
        },
        {
          field: 'comments',
          title: 'Comments',
          template:
            '#= comments && comments.length > 10 ? comments.substring(0, 10) + "..." : (comments || "") #',
          width: 132,
        },
        {
          field: 'languageName',
          title: 'Language',
          width: 120,
          editor: this.languageEditor,
        },
        {
          field: 'dashboardId',
          title: 'Dashboard',
          width: 132,
          editor: this.dashboardEditor,
          template: '#:dashboardName# ',
        },
        {
          field: 'mailTitle',
          title: 'Mail Title',
          template:
            '#= mailTitle && mailTitle.length > 10 ? mailTitle.substring(0, 10) + "..." : (mailTitle || "") #',
          width: 132,
          editor: this.mailTitleEditor,
        },
        {
          field: 'sendingDate',
          title: 'Sending Date',
          width: 161,
          attributes: {style: 'text-align:right'},
          format: '{0:yyyy-MM-dd HH:mm:ss}',
          editor: readOnlyEditor,
        },
        {
          field: 'from',
          title: 'From',
          width: 182,
          editor: this.fromEditor,
          hidden: true,
        },
        {
          field: 'sendingUser',
          title: 'Sending User',
          width: 182,
          editor: readOnlyEditor,
        },
        {
          editable: !this.isReadOnly,
          command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
          attributes: {style: 'text-align:center;padding:0'},
          width: 40,
        },
        {},
      ].filter(c => c.editable !== false)
    },
    uploadUrl() {
      return '/api/report/monthlyReportSendingList/importContactList?reportDate=' + this.asOfDate
    },
    selectedAsOfDate() {
      return this.asOfDate
    },
  },
  components: {
    PageToolbar,
    DashboardBonCoupEmail,
    DashboardBonCoupConfirmForm,
    AzureStorage,
    BonCoupNewListConfirmForm,
    DashboardBonCoupValidateAllConfirmForm,
    VonapToolbarLabel,
    AnalystEmail,
    ResponsibleEmail,
    SendingMessageWindow,
    DashboardBonCoupPreview,
  },
}
</script>

<style>
.page_toolbar .v-toolbar__content {
  height: 55px !important;
}
</style>
